// Teams API on new Users service

import axios from '../requester';
import { LINB_API } from 'common/constants/api-urls';

export const getTeamMembers = async teamId => {
  return axios.get(`${LINB_API.TEAMS_V2_SERVICE.TEAMS}/${teamId}/members`);
};

export const createTeam = async ({
  name,
  initials,
  color,
  parentTeamId,
  userIds = [], // {id, joined_at}
  childTeamIds = []
}) => {
  return axios.post(LINB_API.TEAMS_V2_SERVICE.TEAMS, {
    name,
    initials,
    color,
    ...(parentTeamId && { parentId: parentTeamId }),
    ...(userIds?.length && { user_ids: userIds }),
    ...(childTeamIds?.length && { childTeamIds })
  });
};

export const updateTeam = async (
  teamId,
  {
    name,
    initials,
    color,
    parentTeamName,
    userIds = [], // {id, joined_at}
    childTeamIds = []
  } = {}
) => {
  return axios.patch(`${LINB_API.TEAMS_V2_SERVICE.TEAMS}/${teamId}`, {
    ...(name && { name }),
    ...(initials && { initials }),
    ...(color && { color }),
    ...(parentTeamName && { parent_team: parentTeamName }),
    ...(userIds?.length && { user_ids: userIds }),
    ...(childTeamIds?.length && { children_team_ids: childTeamIds })
  });
};
/* eslint-enable import/no-unused-modules */
